import ReplyIcon from '@mui/icons-material/Reply';
import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import useStyles from '../indexcss';
import chatMessages from './chatMessages.json';
import ChatBox from './chatBox';

interface TicketData {
  header: string;
  status: string;
  ticketNumber: string;
  ticketDate: string;
  requestType: string;
  description: string;
}

interface ChatTicketProps {
  ticketData: TicketData;
}

interface Message {
  sender: string;
  date: string;
  time: string;
  header: string;
  description: string;
  replies?: Message[];
}

const ChatTicket: React.FC<ChatTicketProps> = ({ ticketData }) => {
  const classes = useStyles();
  const [isChatBoxOpen, setChatBoxOpen] = useState(false);

  const handleReplyClick = () => {
    setChatBoxOpen(true);
  };

  const handleChatBoxClose = () => {
    setChatBoxOpen(false);
  };

  const mockMessages: Message[] = chatMessages;

  return (
    <div className={classes.customScrollbarContainerTicket}>
      {mockMessages.map((message, index) => (
        <div key={index}>
          <Typography className={classes.Typdisplay}>
            <span className={`${classes.SenderTypo} ${message.sender === 'Admin' || message.sender === 'You' ? classes.AdminSender : ''}`}>{message.sender}</span>
            <span className={`${classes.SenderTypo}`}>
              | {message.date} | {message.time}
            </span>
          </Typography>
          <Box className={`${classes.MessageBox} ${message.sender === 'You' ? classes.YouMessageBox : ''} ${message.sender === 'Admin' ? classes.AdminMessageBox : ''}`}>
            <div>
              <Typography className={classes.headerchattypo}>
                {message.sender === 'You' ? 'Hi Admin' : 'Hi'}, {message.header}
              </Typography>
              <Typography className={classes.descriptionChatTypo}>{message.description}</Typography>
              {message.sender === 'Admin' && (
                <IconButton className={classes.replyicon} aria-label="reply" onClick={handleReplyClick}>
                  <ReplyIcon />
                  Reply
                </IconButton>
              )}
            </div>
          </Box>
        </div>
      ))}
      {isChatBoxOpen && <ChatBox onClose={handleChatBoxClose} />}
    </div>
  );
};

export default ChatTicket;
